import React, { CSSProperties } from "react";
import { FieldRenderProps } from "react-final-form";
import styled from "styled-components";

import { FieldInput } from "./FieldInput";

type Props = FieldRenderProps<string, HTMLElement> & {
  className?: string;
  help?: string;
  label?: string;
  style?: CSSProperties;
  wrapperStyling?: CSSProperties;
};

export const TextField = ({
  className,
  help,
  input,
  label,
  placeholder,
  meta: { error },
  style,
  wrapperStyling,
}: Props): JSX.Element => {
  return (
    <Wrapper style={wrapperStyling}>
      <FieldInput
        className={className}
        error={error}
        help={help}
        style={style}
        {...input}
        label={label}
        name={input.name}
        onChange={input.onChange}
        type="text"
        value={input.value}
        placeholder={placeholder}
      />
    </Wrapper>
  );
};

const Wrapper = styled.div`
  margin: 24px;
`;

export default TextField;
